@if (data() && columns()) {
    <table class="dataGrid">
        <thead>
            <tr>
                @for (column of processedColumns(); track column; let index = $index) {
                    <th>
                        <div
                            class="cellWrapper"
                            (click)="changeSort(index)"
                            [ngClass]="{
                                sortable: column.sortable,
                                sortActive: index === sorting().column,
                                changeTrackingHeader: column.dataKey === 'widgetComparisonState',
                            }"
                        >
                            <span class="headerText">{{ column.headerLabel ?? ' ' | translate }}</span>
                            @if (column.sortable) {
                                <i
                                    class="far fa-fw"
                                    [ngClass]="{
                                        'fa-arrows-up-down': sorting().column !== index || sorting().direction === 0,
                                        'fa-arrow-up': sorting().column === index && sorting().direction === -1,
                                        'fa-arrow-down': sorting().column === index && sorting().direction === 1,
                                    }"
                                ></i>
                            }
                        </div>
                    </th>
                }
            </tr>
        </thead>
        @if (data()) {
            <tbody>
                @for (
                    item of data()
                        | dataGridSorter: processedColumns()[sorting().column] : sorting().direction : sorting().dataPreprocessor;
                    track item;
                    let index = $index
                ) {
                    <tr [ngClass]="itemStylesMap().get($any(item))" [attr.table-room-id]="$any(item)?.id">
                        @for (column of processedColumns(); track column) {
                            <td [style.width]="column.width" [class]="column.computedCellClass">
                                <ng-container [appDataGridComponentInjector]="[column, item]" />
                            </td>
                        }
                    </tr>
                }
            </tbody>
        }
        <tfoot></tfoot>
    </table>
}
